import { BroadcastChannel } from 'broadcast-channel';

export const AppleHandler = () => {
  const channel = new BroadcastChannel('auth-apple-code');

  const token = (window as any).apple_token;

  channel.postMessage({
    success: !token.error,
    payload: token,
  });

  setTimeout(() => {
    window.close();
  }, 250);
};
